/**
 * LVD Dual Size Validation — v3
 * Requires BOTH Men's and Women's size before cart / checkout.
 * Works on product page + quickview modal.
 */
(function () {
  'use strict';

  /* ── 1. POPUP ── */
  function injectPopup() {
    if (document.getElementById('lvd-size-popup')) return;

    var s = document.createElement('style');
    s.textContent = [
      '#lvd-size-popup{display:none;position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:2147483647;align-items:center;justify-content:center}',
      '#lvd-size-popup.show{display:flex}',
      '#lvd-size-popup-box{background:#fff;border-radius:12px;padding:1.4rem 2.2rem 1.4rem 1.6rem;max-width:310px;width:92%;box-shadow:0 8px 30px rgba(0,0,0,.16);display:flex;align-items:flex-start;gap:1rem;animation:lvdIn .26s cubic-bezier(.22,1,.36,1);position:relative}',
      '#lvd-size-popup-box::before{content:"";position:absolute;left:0;top:0;bottom:0;width:3px;background:#e07b39;border-radius:12px 0 0 12px}',
      '@keyframes lvdIn{from{transform:translateY(-16px);opacity:0}to{transform:translateY(0);opacity:1}}',
      '#lvd-size-popup-icon{font-size:1.8rem;line-height:1;flex-shrink:0;margin-top:.05rem}',
      '#lvd-size-popup-text{flex:1}',
      '#lvd-size-popup-title{font-size:1.3rem;font-weight:700;color:#111;margin:0 0 .3rem;font-family:inherit}',
      '#lvd-size-popup-msg{font-size:1.2rem;color:#666;margin:0 0 .9rem;line-height:1.5;font-family:inherit}',
      '#lvd-size-popup-msg strong{color:#222;font-weight:600}',
      '#lvd-size-popup-ok{background:#153330;color:#fff;border:none;border-radius:6px;padding:.45rem 1.2rem;font-size:1.15rem;font-weight:600;cursor:pointer;font-family:inherit;transition:opacity .15s}',
      '#lvd-size-popup-ok:hover{opacity:.82}',
      '#lvd-size-popup-x{position:absolute;top:.5rem;right:.6rem;background:none;border:none;cursor:pointer;color:#bbb;font-size:1.5rem;line-height:1;padding:.2rem;transition:color .15s}',
      '#lvd-size-popup-x:hover{color:#555}'
    ].join('');
    document.head.appendChild(s);

    var o = document.createElement('div');
    o.id = 'lvd-size-popup';
    o.innerHTML =
      '<div id="lvd-size-popup-box">' +
        '<span id="lvd-size-popup-icon">\u26a0\ufe0f</span>' +
        '<div id="lvd-size-popup-text">' +
          '<div id="lvd-size-popup-title">Select Both Sizes</div>' +
          '<p id="lvd-size-popup-msg">Please choose a <strong>Men\'s</strong> and <strong>Women\'s</strong> size before continuing.</p>' +
          '<button id="lvd-size-popup-ok" type="button">Got it</button>' +
        '</div>' +
        '<button id="lvd-size-popup-x" type="button" aria-label="Close">&#x2715;</button>' +
      '</div>';
    document.body.appendChild(o);

    document.getElementById('lvd-size-popup-ok').addEventListener('click', hide);
    document.getElementById('lvd-size-popup-x').addEventListener('click', hide);
    o.addEventListener('click', function (e) { if (e.target === o) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  }

  function show() { var e = document.getElementById('lvd-size-popup'); if (e) e.classList.add('show'); }
  function hide() { var e = document.getElementById('lvd-size-popup'); if (e) e.classList.remove('show'); }

  /* ── 2. DETECT dual-size page ── */
  function isDualPage() {
    if (document.querySelector('.lvd-dual-size-selector')) return true;
    if (document.querySelector('.dual-size-selector-wrapper')) return true;
    if (document.querySelector('.lvd-mens-radio')) return true;
    if (document.querySelector('.size-radio-input')) return true;
    return false;
  }

  /* ── 3. CHECK both selected ──
     Strategy: look for checked .size-radio-input or .lvd-*-radio elements
     and check their name attribute contains "Men" or "Women".            */
  function bothSelected() {
    /* Case A – custom-size-selector.liquid (lvd-mens-radio / lvd-womens-radio) */
    var mensRadios = document.querySelectorAll('.lvd-mens-radio');
    if (mensRadios.length > 0) {
      var mOk = !!document.querySelector('.lvd-mens-radio:checked');
      var wOk = !!document.querySelector('.lvd-womens-radio:checked');
      return mOk && wOk;
    }

    /* Case B – dual-gender-size-selector.liquid (.size-radio-input)
       Names: "properties[Men's Size]" and "properties[Women's Size]"   */
    var allSizeRadios = document.querySelectorAll('.size-radio-input');
    if (allSizeRadios.length > 0) {
      var mensChecked = false;
      var womensChecked = false;
      allSizeRadios.forEach(function (inp) {
        if (!inp.checked) return;
        var n = inp.name || '';
        if (n.indexOf('Men') !== -1)   mensChecked = true;
        if (n.indexOf('Women') !== -1) womensChecked = true;
      });
      return mensChecked && womensChecked;
    }

    return true; /* no dual-size selector on this page */
  }

  /* ── 4. IS IT A CART / CHECKOUT BUTTON? ── */
  function getCartBtn(target) {
    if (!target || !target.closest) return null;
    /* skip popup itself */
    if (target.closest('#lvd-size-popup')) return null;
    /* skip wishlist / compare */
    if (target.closest('.bls__product-wishlist, .bls__product-wishlist-js, [data-pro-add-wishlist], [data-pro-remove-wishlist], .wishlist-icon-bubble, .bls__product-compare')) return null;
    /* match cart/checkout buttons */
    return target.closest(
      'button[name="add"],' +
      '.add-cart-button,' +
      '.button-add-cart-qv,' +
      '.product-form__submit,' +
      '.shopify-payment-button__button,' +
      '[data-testid="Checkout-button"],' +
      '.bls__dual-buy-now-js'
    );
  }

  /* ── 5. INTERCEPT — click (capture phase) ── */
  document.addEventListener('click', function (e) {
    if (!isDualPage()) return;
    var btn = getCartBtn(e.target);
    if (!btn) return;
    if (!bothSelected()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      show();
    }
  }, true);

  /* ── 6. INTERCEPT — form submit (capture phase) ── */
  document.addEventListener('submit', function (e) {
    if (!isDualPage()) return;
    var f = e.target;
    if (!f || !f.id) return;
    if (f.id.indexOf('product-form-') !== 0 && f.id.indexOf('sticky-addcart-form-') !== 0) return;
    if (!bothSelected()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      show();
    }
  }, true);

  /* ── 7. WATCH for Shopify payment buttons rendered asynchronously ──
     Shopify's dynamic checkout buttons are injected after DOMContentLoaded.
     We use MutationObserver to add a transparent overlay blocker over the
     payment button container when sizes are not both selected.            */
  function watchPaymentButtons() {
    var observer = new MutationObserver(function () {
      var containers = document.querySelectorAll('.shopify-payment-button, .bls__payment-button');
      containers.forEach(function (container) {
        if (container.dataset.lvdWatched) return;
        container.dataset.lvdWatched = '1';
        container.addEventListener('click', function (e) {
          if (!isDualPage()) return;
          if (e.target.closest('#lvd-size-popup')) return;
          if (e.target.closest('.bls__product-wishlist, .bls__product-wishlist-js')) return;
          if (!bothSelected()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            show();
          }
        }, true);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ── 8. LABEL SYNC for custom radios ── */
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.classList.contains('custom-size-radio-input')) return;
    var isM = r.classList.contains('lvd-mens-radio');
    var isW = r.classList.contains('lvd-womens-radio');
    if (!isM && !isW) return;
    var g = isM ? '.lvd-mens-radio' : '.lvd-womens-radio';
    document.querySelectorAll(g).forEach(function (i) {
      var l = document.querySelector('label[for="' + i.id + '"]');
      if (l) l.classList.remove('active');
    });
    var a = document.querySelector('label[for="' + r.id + '"]');
    if (a) a.classList.add('active');
  });

  /* ── 9. INIT ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectPopup();
      watchPaymentButtons();
    });
  } else {
    injectPopup();
    watchPaymentButtons();
  }

})();
